<template>
    <div class="container" v-if="viewed.length > 0">
        <div class="product_container firm-sec__product_container">
            <h3 class="category-title">{{ trans('Recently viewed') }}</h3>
            <div class="collection-slider-sec__slider_wrapper">
                <swiper
                    class="swiper-viewed_products swiper swiper-initialized swiper-horizontal product-row firm-sec_row product-mob-slider swiper-backface-hidden "
                    :modules="modules"
                    :space-between="15"
                    :pagination="{ clickable: true }"
                    :breakpoints="{
                      '640': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                      },
                      '768': {
                        slidesPerView: 4,
                        spaceBetween: 40,
                      },
                      '1024': {
                        slidesPerView: 5,
                        spaceBetween: 50,
                      },
                    }"
                >

                    <swiper-slide class="swiper-slide product" v-for="(view, cardIndex) in viewed" :key="view.id">
                        <a :href="view.slug" :title="view.name" class="product__wrapper"
                           @click="onSelectItem(view, cardIndex)">
                            <div class="product__image_wrapper">
                                <div v-if="showPreorder(view)" class="preorder">
                                    <span>{{ trans("Pre-order") }}</span>
                                </div>
                                <picture class="product__image product__first-image">
                                    <source
                                        :srcset="view.img_first.webp"
                                        type="image/webp">
                                    <img :src="view.img_first.jpg"
                                         :alt="view.name"
                                         class="product__image product__first-image">
                                </picture>
                                <picture class="product__image product__second-image">
                                    <source
                                        :srcset="view.img_last.webp"
                                        type="image/webp">
                                    <img :src="view.img_last.jpg"
                                         :alt="view.name"
                                         class="product__image product__second-image">
                                </picture>
                                <span @click.prevent="updateLike(view)" :class="view.favourites ? 'active-like' : '' " class="add-like">
                                    <svg class="svg-icon" width="22" height="18" viewBox="0 0 22 18" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 17.25C11 17.25 1.625 12 1.625 5.62501C1.625 4.49803 2.01546 3.40585 2.72996 2.53431C3.44445 1.66277 4.43884 1.0657 5.54393 0.844677C6.64903 0.623658 7.79657 0.792346 8.79131 1.32204C9.78605 1.85174 10.5665 2.70972 11 3.75001V3.75001C11.4335 2.70972 12.2139 1.85174 13.2087 1.32204C14.2034 0.792346 15.351 0.623658 16.4561 0.844677C17.5612 1.0657 18.5555 1.66277 19.27 2.53431C19.9845 3.40585 20.375 4.49803 20.375 5.62501C20.375 12 11 17.25 11 17.25Z"
                                        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </span>
                            </div>

                            <div class="product__info">
                                <h3 class="product__title">
                                    <span class="product__title-link">{{view.name}}</span>
                                </h3>
                                <div class="product__price-row">
                                    <template v-if="view.offer.price_old_str">
                                        <p class="product__sale-price product__text-def"> {{ view.offer.price_str }} {{ view.signs }}</p>
                                        <p class="product__old-price"> {{ view.offer.price_old_str }} {{ view.signs }}</p>
                                    </template>
                                    <p class="product__main-price product__text-def" v-if="!view.offer.price_old_str">{{ view.offer.price_str }}
                                        {{ view.signs }}</p>
                                </div>
                            </div>
                        </a>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
import {Navigation, Pagination} from 'swiper/modules';

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';
import { selectItem, viewItemList } from '../services/ga4Ecommerce.js';

// Import Swiper styles
import 'swiper/css';
// import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';
import 'swiper/css';
// import 'swiper/swiper-bundle.css';
export default {
name: "viewed",
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            modules: [Navigation, Pagination],
            viewed:[],
        }
    },
    mounted() {
        this.getCards()
    },
    methods:{
        showPreorder(card) {
            return (card.preorder_ru && this.$store.state.settings.site_id === 1) || (card.preorder_world && this.$store.state.settings.site_id === 2)
        },
        checkLike(cards) {
            let favourites = this.$store.state.settings.basket.favourites
            cards.forEach(function(card) {
                if (favourites.find(it => it.card_id === card.id)) {
                    card.favourites = true
                }
            })
            return cards
        },
        updateLike(card){
            card.favourites = !card.favourites
            this.$parent.$parent.$refs.header.updateLike(card)
        },
        onSelectItem(card, index) {
            selectItem(card, 'viewed', 'Recently viewed', index + 1)
        },

        async getCards() {
            await axios.post('/api/v1/get-cards-ids', this.setParam({
                viewed:this.$store.state.settings.basket.viewed,
                stock: true,
                from: 'viewed',
                guest: this.$store.state.settings.guest.id,
            }))
            .then(data => {
                if (data.data['basket']) {
                    this.$store.state.settings.basket.viewed = data.data['basket']
                    this.updateStorage(this.$store.state.settings)
                }
                this.viewed =  this.checkLike(data.data['cards'])
                viewItemList(this.viewed, 'viewed', 'Recently viewed')
            })
        },
    }
}
</script>

<style scoped>
.product__image_wrapper {
    position: relative;
}
</style>
